import { useTranslation } from 'react-i18next';

// Dil (TR/EN) anahtarı — navbar'da kullanılır. (Site kalıcı koyu metalik
// temada çalıştığından açık/koyu tema anahtarı kaldırıldı.)
const ThemeLangControls = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language === 'en' ? 'en' : 'tr';
  const languages = [
    { value: 'tr', label: 'TR' },
    { value: 'en', label: 'EN' },
  ] as const;

  return (
    <div
      className="relative grid h-9 w-[5.75rem] grid-cols-2 overflow-hidden rounded-full p-1"
      role="group"
      aria-label="Language"
    >
      <span
        aria-hidden
        className={`absolute bottom-1 left-1 top-1 w-[calc(50%-0.25rem)] rounded-full bg-[#2f6bff] shadow-[0_0_18px_rgba(47,102,255,0.55)] transition-transform duration-300 ease-out ${
          lang === 'en' ? 'translate-x-full' : 'translate-x-0'
        }`}
      />
      {languages.map((item) => {
        const active = lang === item.value;
        return (
          <button
            key={item.value}
            type="button"
            onClick={() => i18n.changeLanguage(item.value)}
            aria-pressed={active}
            className={`relative z-10 rounded-full text-xs font-extrabold tracking-[0.12em] transition-colors duration-200 ${
              active ? 'text-white' : 'text-[#CED1D1]/72 hover:text-[#5f9bff]'
            }`}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeLangControls;
